import { CMProgressStep } from "@pscsrvlab/psc-react-components";
import React, { memo } from "react";
import { ComponentStyleProps } from "../../../../lib/styles/props/component-style-props";
import { useAppTranslation } from "../../../../hooks/use-app-translation";

export type ProgressStepDocumentRevisionProps = {
  currentStep?: 0 | 1 | 2;
} & ComponentStyleProps;
export const ProgressStepDocumentRevision = memo(
  function ProgressStepDocumentRevision({
    currentStep,
    sx,
    ...rest
  }: ProgressStepDocumentRevisionProps) {
    const { t } = useAppTranslation();
    return (
      <CMProgressStep
        steps={[
          { label: "STEP1", description: t("lbl.修正") },
          { label: "STEP2", description: t("lbl.修正内容確認") },
          { label: "STEP3", description: t("lbl.提出完了") },
        ]}
        currentStep={currentStep}
        sx={{
          w: "100%",
          maxW: "720px",
          minW: "300px",
          pt: "20px",
          display: "flex",
          justifyContent: "center",
          ...sx,
        }}
        {...rest}
      />
    );
  },
);
